export const API_EMAIL_SUBSCRIPTION = 'core/subscription-by-email';
